import styled from 'styled-components'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'

const Caption = styled.figcaption`
    display: block;
    font-size: 12px;
    font-style: italic;
    line-height: 1.5em;
    text-align: center;

    @media (min-width: ${TABLET}px) {
        font-size: 14px;
    }

    @media (min-width: ${DESKTOP}px) {
        font-size: 16px;
    }
`

const Figure = styled.figure`
    margin: 0;
`

Object.assign(Figure, {
    Caption,
})

export default Figure
